export const modalZIndex = () => 2000;

/**
 * Prevents html buttons from being triggered by enter key
 */
export const disableEnterKey = action => e => {
  if (e.detail > 0) {
    action();
  } else {
    e.preventDefault();
    return false;
  }
};
